import axios from 'axios'
import config from '../config'
import { getUserToken } from "../utils"

const getSubGroupListApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}common-master/sub-group-list`,
        method: "get",
        params: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getUserToken()}`
        }
    })

    return response

}

export default getSubGroupListApi